module.exports = __webpack_public_path__ + "img/사각파라솔 (1).0542b932.jpg";